query getUserPreferencesForCurrentUser {
  userPreferences: getUserPreferencesForCurrentUser {
    userId
    scope
    createdAt
    updatedAt
    preferences
  }
}

mutation updateUserPreferencesForCurrentUser(
  $preferences: [UserPreferencesUpdate!]!
) {
  userPreferences: updateUserPreferencesForCurrentUser(
    preferences: $preferences
  ) {
    userId
    scope
    createdAt
    updatedAt
    preferences
  }
}
